/**
 * Custom bar shape for a recharts' <Bar> component.
 * Draw a rectangle with a stroke, and hatches (optional)
 */
import React from 'react';

const HatchedBarWithStroke = (props) => {
    const { x, y: originalY, width, fill, height: originalHeight, hatched } = props;

    // Negative height not supported for <rect>. Adjust Y accordingly
    const height = Math.abs(originalHeight);
    const y = originalY + (originalHeight < 0 ? originalHeight : 0);
    const darkGray = '#535963';

    const baseRectangle = <rect stroke={darkGray} fill={fill} x={x} y={y} width={width} height={height} />;
    if (!hatched) return baseRectangle;

    // The <Bar> is rendered in a <BarChart>, which defines an <svg>, therefore
    // we can directly insert the pattern here.
    // - First rectangle draws the coloured background,
    // - Second rectangle draws the pattern on top
    return (
        <>
            <defs>
                <pattern
                    id="pattern-stripe"
                    width="8"
                    height="8"
                    patternUnits="userSpaceOnUse"
                    patternTransform="rotate(45)"
                >
                    <rect width="2" height="8" fill={darkGray} />
                </pattern>
            </defs>

            {baseRectangle}
            <rect fill="url(#pattern-stripe)" x={x} y={y} width={width} height={height} />
        </>
    );
};

export default HatchedBarWithStroke;
